/**
 * Navigation, gear-menu and "+ New" labels in Arabic, keyed by the English label in
 * apps/web/src/app/navigation.ts (document 15, section 5.3). A label missing here shows in
 * English; the web test suite checks every label has one.
 */
export const NAV_AR: Readonly<Record<string, string>> = {
  Accounting: 'المحاسبة',
  'AI Accountant': 'المحاسب الذكي',
  'All sales': 'جميع المبيعات',
  Approvals: 'الموافقات',
  Attachments: 'المرفقات',
  'Audit log': 'سجل التدقيق',
  'Bank deposit': 'إيداع بنكي',
  'Bank transactions': 'المعاملات البنكية',
  Banking: 'البنوك',
  Bill: 'فاتورة مورد',
  Bills: 'فواتير الموردين',
  Budgets: 'الموازنات',
  'Chart of accounts': 'دليل الحسابات',
  Classes: 'الفئات',
  Clients: 'الشركات العميلة',
  'Company settings': 'إعدادات الشركة',
  'Corporate tax': 'ضريبة الشركات',
  'Credit note': 'إشعار دائن',
  Currencies: 'العملات',
  Customer: 'عميل',
  Customers: 'العملاء',
  Dashboard: 'لوحة المعلومات',
  'Debit note': 'إشعار مدين',
  'Delivery challan': 'إذن تسليم',
  'Delivery challans': 'أذون التسليم',
  Documents: 'المستندات',
  'E-invoicing': 'الفوترة الإلكترونية',
  Expense: 'مصروف',
  Expenses: 'المصروفات',
  'Export data': 'تصدير البيانات',
  'Fixed assets': 'الأصول الثابتة',
  GST: 'ضريبة السلع والخدمات',
  Home: 'الرئيسية',
  'Import data': 'استيراد البيانات',
  'Import statement': 'استيراد كشف حساب',
  Inbox: 'الوارد',
  'Inventory qty adjustment': 'تسوية كمية المخزون',
  'Invoice templates': 'قوالب الفواتير',
  Invoice: 'فاتورة',
  Invoices: 'الفواتير',
  'Journal entries': 'قيود اليومية',
  'Journal entry': 'قيد يومية',
  'Keyboard shortcuts': 'اختصارات لوحة المفاتيح',
  Lists: 'القوائم',
  Locations: 'المواقع',
  'Manage users': 'إدارة المستخدمين',
  'Management reports': 'التقارير الإدارية',
  Messages: 'الرسائل',
  'Move from QuickBooks': 'الانتقال من QuickBooks',
  'My practice': 'مكتبي',
  Notifications: 'الإشعارات',
  Other: 'أخرى',
  Overview: 'نظرة عامة',
  'Pay bills': 'سداد فواتير الموردين',
  'Periods and close': 'الفترات والإقفال',
  'Product/service': 'منتج أو خدمة',
  'Products and services': 'المنتجات والخدمات',
  'Profile and security': 'الملف الشخصي والأمان',
  Profile: 'الملف الشخصي',
  Projects: 'المشاريع',
  'Purchase order': 'أمر شراء',
  'Purchase orders': 'أوامر الشراء',
  Quote: 'عرض سعر',
  Quotes: 'عروض الأسعار',
  Receipts: 'الإيصالات',
  'Receive payment': 'استلام دفعة',
  'Reclassify transactions': 'إعادة تصنيف المعاملات',
  Reconcile: 'التسوية البنكية',
  'Recurring transaction': 'معاملة متكررة',
  'Recurring transactions': 'المعاملات المتكررة',
  'Refund receipt': 'إيصال استرداد',
  Reports: 'التقارير',
  Rules: 'القواعد',
  'Sales order': 'أمر بيع',
  'Sales orders': 'أوامر البيع',
  'Sales receipt': 'إيصال مبيعات',
  Sales: 'المبيعات',
  'Sent emails': 'الرسائل المرسلة',
  Settings: 'الإعدادات',
  Statement: 'كشف حساب',
  'Switch client': 'تبديل الشركة',
  Tags: 'الوسوم',
  'Tax rates': 'نسب الضريبة',
  Taxes: 'الضرائب',
  Team: 'الفريق',
  Tools: 'الأدوات',
  Transactions: 'المعاملات',
  Transfer: 'تحويل',
  'Trial balance': 'ميزان المراجعة',
  VAT: 'ضريبة القيمة المضافة',
  Vendor: 'مورد',
  Vendors: 'الموردون',
  'Voided and reversed transactions': 'المعاملات الملغاة والمعكوسة',
  'Write off invoices': 'شطب الفواتير',
  'Your company': 'شركتك',
  'Coming soon': 'قريباً',
};
